import React from 'react';
import WrapperLayout from 'layouts/WrapperLayout';
import { useTranslation } from 'react-i18next';
import NotifyContainer from 'containers/NotifyContainer';

type Props = {};

export default function NotifyPage({}: Props) {
  const { t } = useTranslation();

  return (
    <WrapperLayout title={t('title.notify')}>
      <NotifyContainer />
    </WrapperLayout>
  );
}
